import React, { useState, useEffect } from 'react';
import { Container, Group, Burger, Drawer, Stack, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import classes from './Header.module.css';

export default function Header() {
  const [opened, { toggle, close }] = useDisclosure(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const items = [
    { link: '/', label: 'Home' },
    { link: '/about', label: 'About Us' },
    { link: '/products/control-forge', label: 'Products' },
    { link: '/contact', label: 'Contact' },
  ];
  
  const links = items.map((item) => (
    <Link
      key={item.label}
      to={item.link}
      className={`${classes.link} ${location.pathname === item.link ? classes.active : ''}`}
      onClick={close}
    >
      {item.label}
    </Link>
  ));

  return (
    <header className={`${classes.header} ${scrolled ? classes.scrolled : ''}`}>
      <Container size="xl" className={classes.inner}>
        <Link to="/" className={classes.logo}>
          <img
            src="/images/optifyne_horizontal.png"
            alt="Optifyne - Process Automation & Integration Solutions"
            className={classes.logoImage}
            width="180"
            height="40"
            loading="eager"
          />
        </Link>
        
        <Group gap={5} visibleFrom="xs" className={classes.links}>
          {links}
        </Group>
        
        <motion.div 
          whileHover={{ scale: 1.05 }} 
          whileTap={{ scale: 0.95 }}
          className={classes.ctaButtonWrapper}
          visibleFrom="sm"
        >
          <Button 
            component={Link} 
            to="/contact" 
            className={classes.ctaButton}
          >
            Get Started
          </Button>
        </motion.div>
        
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" />
      </Container>
      
      <Drawer
        opened={opened}
        onClose={close}
        size="100%"
        padding="md"
        title="Navigation"
        hiddenFrom="sm"
        zIndex={1000000}
      >
        <Stack>
          {links}
          <Button 
            component={Link} 
            to="/contact" 
            className={classes.ctaButton}
            fullWidth
            onClick={close}
          >
            Get Started
          </Button>
        </Stack>
      </Drawer>
    </header>
  );
}
